import script from "./SymbolPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SymbolPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SymbolPanel.vue?vue&type=style&index=0&id=568ddaa4&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568ddaa4"]])

export default __exports__